import {AppShell, Box, Burger, Group} from '@mantine/core'
import {useDisclosure} from '@mantine/hooks'
import {Outlet, useRouterState} from '@tanstack/react-router'
import {useEffect} from 'react'

import {GoogleMapsProvider} from '../jobs/google-maps/google-maps-provider'
import {SyncSentryUser} from '../sentry/sync-sentry-user'
import {AppBrandMark} from './app-brand-mark'
import {AppNavbar} from './app-navbar'
import {
    ENVIRONMENT_BANNER_HEIGHT,
    EnvironmentBanner,
    environmentBannerText,
} from './environment-banner'

const MOBILE_HEADER_HEIGHT = 56

export function AppShellLayout() {
    const pathname = useRouterState({select: (state) => state.location.pathname})
    const [mobileOpened, {toggle, close}] = useDisclosure()
    const bannerText = environmentBannerText()
    const bannerHeight = bannerText ? ENVIRONMENT_BANNER_HEIGHT : 0

    useEffect(() => {
        close()
    }, [pathname, close])

    return (
        <GoogleMapsProvider>
            <AppShell
                header={{
                    height: {base: MOBILE_HEADER_HEIGHT + bannerHeight, sm: bannerHeight},
                }}
                navbar={{
                    width: 210,
                    breakpoint: 'sm',
                    collapsed: {mobile: !mobileOpened},
                }}
                padding="md"
            >
                <SyncSentryUser />
                <AppShell.Header bg="var(--mt-brand-chrome)" withBorder={false}>
                    {bannerText && <EnvironmentBanner text={bannerText} />}
                    <Group h={MOBILE_HEADER_HEIGHT} px="md" hiddenFrom="sm">
                        <Burger
                            opened={mobileOpened}
                            onClick={toggle}
                            hiddenFrom="sm"
                            size="sm"
                            color="var(--mt-brand-on-chrome)"
                            aria-label="Open navigation"
                            aria-expanded={mobileOpened}
                        />
                        <Box hiddenFrom="sm">
                            <AppBrandMark size="sm" />
                        </Box>
                    </Group>
                </AppShell.Header>
                <AppShell.Navbar p={0}>
                    <AppNavbar onNavigate={close} />
                </AppShell.Navbar>
                <AppShell.Main>
                    <Outlet />
                </AppShell.Main>
            </AppShell>
        </GoogleMapsProvider>
    )
}
